import { z } from "zod";

const FaqItemSchema = z.object({
  question: z.string(),
  answer: z.string(),
});

type FaqItem = z.infer<typeof FaqItemSchema>;

const stripHtmlRegex = (html: string): string => {
  return html.replace(/<[^>]*>/g, "");
};

const makeFaqSchema = (faqData: FaqItem[]): FAQPageSchema => {
  const validatedFaqData = z.array(FaqItemSchema).safeParse(faqData);

  if (!validatedFaqData.success) {
    console.error("Invalid FAQ data:", validatedFaqData.error);
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [],
    };
  }

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: validatedFaqData.data.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: stripHtmlRegex(faq.answer),
      },
    })),
  };
};

type FAQPageSchema = {
  "@context": "https://schema.org";
  "@type": "FAQPage";
  mainEntity: {
    "@type": "Question";
    name: string;
    acceptedAnswer: {
      "@type": "Answer";
      text: string;
    };
  }[];
};

export default makeFaqSchema;
